import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { UserGroupService } from '@app/services/user-group.service';

@Component({
    selector: 'tt-user-groups',
    templateUrl: './user-groups.component.html',
    styleUrls: ['./user-groups.component.css'],
})
export class UserGroupsComponent implements OnInit, OnDestroy {
    public userGroups: Item[] = [];

    public selectedUserGroup = '';

    constructor(private datatask: DataTaskService, public userGroup: UserGroupService) {}

    public async onSubmit(event?: { usergroup_keyno: `${number}` | number }) {
        await this.loadUserGroups();

        if (!!event) {
            this.selectedUserGroup = '' + event.usergroup_keyno;
            this.userGroup.setCurrentUserGroup(event);
        }
    }

    public async loadUserGroups() {
        this.userGroups = await this.datatask.Post(98);
    }

    private init() {
        this.loadUserGroups();
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnDestroy(): void {
        this.userGroup.setCurrentUserGroup(null);
    }
}
